export enum FacilityTabId {
  General = 'general',
  LevelsOfCare = 'levels-of-care',
  Residents = 'residents',
  FloorPlan = 'floor-plan',
}

export enum LevelsOfCareTabId {
  Overview = 'overview',
  Rates = 'rates',
}
